exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  background-color: white;\n  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12);\n  padding: 16px;\n  margin: 0 8px; }\n  form .row {\n    display: -ms-flexbox;\n    display: flex; }\n    form .row mat-form-field:nth-child(2) {\n      margin: 0 16px; }\n    form .row > * {\n      -ms-flex-positive: 1;\n          flex-grow: 1; }\n    form .row button {\n      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26); }\n      form .row button[type='submit'] {\n        color: white;\n        background-color: #2196f3; }\n      form .row button:nth-child(2) {\n        background-color: #fafafa; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/admin/components/admin-idea-all/filter/filter.component.scss
// module id = ../../../../../src/app/components/admin/components/admin-idea-all/filter/filter.component.scss
// module chunks = main